module.exports = __webpack_public_path__ + "img/koala-bubble.b8894cb8.svg";